module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("GBvSr"))).then(() => parcelRequire('1iHdE'));